import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
	name: 'filtroMulta'
})
export class FiltroMultaPipe implements PipeTransform {

	transform(itens: any[], filtro: any[]): any {
		if (!itens) return [];
		if (!filtro || filtro.length == 0) return itens;

		console.log(itens);
		console.log(filtro);

		return itens.filter(it => {
			for (let campo in filtro) {
				let val = filtro[campo];
				if (val) {
					// se houver ___, considera o q vem dps como o tipo de comparacao
					let tipo = null;
					let tipo_aux = campo.split('___');
					if (tipo_aux.length > 1) {
						switch (tipo_aux[1]) {
							case 'data_i': tipo = '>='; val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD'); break;
							case 'data_f': tipo = '<='; val = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD'); break;
						}

						campo = tipo_aux[0];
					}

					// verificar se possui filho de filho, separado por $
					// ex: veiculo$veiculo_placa => val = it[veiculo][veiculo_placa]
					let split = campo.split('$');
					let it_val = it;

					for (let s of split)
						if (it_val)
							it_val = it_val[s];

					switch (tipo) {
						case '>=':
							if (!(it_val && it_val >= val))
								return false;
							break;

						case '<=':
							if (!(it_val && it_val <= val))
								return false;
							break;

						default:
							if (typeof it_val == 'string')  {
								if (!(it_val && it_val.toLowerCase().includes(val.toLowerCase())))
									return false;
							}
							else {
								if (!(it_val && it_val == val))
									return false;
							}
					}
				}
			}

			return true;
		});
	}

}
